import { moments } from '../utils'

const cache = {
  days_to_expired: {},
}

export default {
  methods: {
    room_state(room) {
      return this.$store.getters.room_state(room.no)
    },
    room_current_contract(room) {
      return this.$store.getters.current_contract_of_room(room.no)
    },
    room_days_to_expired(room) {
      if (cache.days_to_expired[room._id] != null)
        return cache.days_to_expired[room._id]

      const contract = this.room_current_contract(room)
      if (contract)
        return this.$formatters.date.expiring_days_from_now(contract.date_expire || contract.date_start)
      return Infinity
    },
    room_preorders(room) {
      return this.$store.getters.preorders_of_room(room.no)
    },
    room_pay_unit_month(room) {
      const contract = this.room_current_contract(room)
      if (contract && contract.pay_unit_month !== undefined)
        return contract.pay_unit_month
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/mixins/room.js